import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { UserService } from 'src/app/services/user.service';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/services/data.service';
import { ToastrService } from 'ngx-toastr';
import { CommonInfo } from '../../app.config';
import { InputformatService } from 'src/app/services/inputformat.service';
import swal from 'sweetalert2';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-studenttransformdetailspopup',
  templateUrl: './studenttransformdetailspopup.component.html',
  styleUrls: ['./studenttransformdetailspopup.component.scss']
})
export class StudenttransformdetailspopupComponent implements OnInit {

  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  studentlist: any[];
  displayedColumns: string[] = [
    "sno",
    // "action",
    "umisId",
    "name",
  ];

  constructor(public dialogRef: MatDialogRef<StudenttransformdetailspopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToAdd: any,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private httpClient: HttpClient,
    private dataService: DataService,
    private toaster: ToastrService,
    public dialog: MatDialog,

    private inputFormatService: InputformatService,) {
      debugger
    this.dataSource = new MatTableDataSource(this.dataRecievedToAdd);
      this.dataRecievedToAdd = _.orderBy(dataRecievedToAdd, ["id"], ["desc"]);
      this.dataSource = new MatTableDataSource(this.dataRecievedToAdd);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
     }

  ngOnInit(): void {

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getSerialNumber(index: number) {
    if (this.paginator) {
      return this.paginator.pageIndex * this.paginator.pageSize + index + 1;
    }
    return null; // or a default value, depending on your use case
  
  }

  sendtrue(studenid){
    this.dialogRef.close(studenid);
  }

  onCancel(){
    this.dialogRef.close(false);
  }


}
